module.exports = __webpack_public_path__ + "static/media/Akemi_6031.4c2dce86.jpg";